module.exports = __webpack_public_path__ + "static/media/JibinKim.c4ccde00.jpg";